import * as React from 'react';
import { cn } from '../../lib/utils';

export interface DataCardProps extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  /** Render a subtle green glow around the card (useful for headline panels like the daily briefing). */
  glow?: boolean;
  as?: 'section' | 'article' | 'div';
}

export const DataCard = React.forwardRef<HTMLElement, DataCardProps>(
  (
    { title, subtitle, actions, glow = false, as = 'section', className, children, ...props },
    ref
  ) => {
    const Tag = as as 'section';
    return (
      <Tag
        ref={ref as React.Ref<HTMLElement>}
        className={cn(
          'rounded-lg border border-border bg-bg-card p-5 shadow-sm',
          glow && 'shadow-glow-green border-greeniq-500/25',
          className
        )}
        {...props}
      >
        {(title || actions || subtitle) && (
          <header className="mb-4 flex items-start justify-between gap-3">
            <div className="flex flex-col gap-0.5">
              {title && (
                <h3 className="font-display text-base font-semibold text-fg">
                  {title}
                </h3>
              )}
              {subtitle && (
                <p className="text-xs text-fg-secondary">{subtitle}</p>
              )}
            </div>
            {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
          </header>
        )}
        {children}
      </Tag>
    );
  }
);
DataCard.displayName = 'DataCard';
